import { render, staticRenderFns } from "./golf_public_relations.vue?vue&type=template&id=7c356d14"
import script from "./golf_public_relations.vue?vue&type=script&lang=js"
export * from "./golf_public_relations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports